<form *ngIf="servicesTypeFormGroup" [formGroup]="servicesTypeFormGroup">
    <p-card>
    <div class="grid">
        <div class="col-12 input-field">
            <label for="name">Nombre *</label>
            <input pInputText formControlName="name" d-form-field-error />
        </div>            
    </div>

    <div class="mt-4 flex gap-2 justify-content-end">
        <p-button label="Eliminar" *ngIf="allowDelete&&servicesType.id" icon="pi pi-trash" styleClass="p-button-danger"
            (click)="delete()"></p-button>
        <div class="flex-grow-1"></div>
        <p-button label="Cancelar" icon="pi pi-times" styleClass="p-button-secondary" (click)="cancel()"></p-button>
        <p-button label="Guardar" *ngIf="allowWrite" icon="pi pi-check" styleClass="p-ml-2"
            (click)="save()"></p-button>
    </div>
</p-card>

    <p-tabView *ngIf="servicesType.id">
                    
        <p-tabPanel header="Compañías" >
          <div class="flex justify-content-end pb-1">
            <p-button label="Añadir compañía" (click)="addCompany({}, false)" styleClass="p-button-sm"
              *ngIf="allowWrite"></p-button>
          </div>
          <p-table styleClass="mt-4" [value]="companies" [paginator]="true" [rows]="25"
            [totalRecords]="totalCompaniesRecords" [showCurrentPageReport]="true"
            currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
            [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body"
            dataKey="companyId" rowGroupMode="subheader" groupRowsBy="companyId"
            >
            <ng-template pTemplate="header" let-columns>
              <tr>
                <th pSortableColumn="company">Compañía <p-sortIcon field="company"></p-sortIcon></th>
                <th >Contrato </th>
                <th width="100"></th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-company let-columns="columns">
              <tr>
                <td>                    
                    {{company.companyId != null?company.company?.name: "Todas"}}
                </td>
                <td>
                  {{company.contractId != null?company.contract?.name: "Todos"}}
              </td>
                <td>
                  <div class="flex gap-2 justify-content-end">
                    <p-button *ngIf="allowDelete" (click)="deleteCompany(company)" [rounded]="true"
                      styleClass="p-button-xs p-button-danger"><i class="pi pi-trash"></i></p-button>
                  </div>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage" let-columns>
              <tr>
                <td [attr.colspan]="2">
                  No se han encontrado compañías
                </td>
              </tr>
            </ng-template>
          </p-table>
        </p-tabPanel>            
      </p-tabView>
</form>
<p-confirmDialog></p-confirmDialog>